import Typography from "@material-ui/core/Typography";
import { StaffErrorFragment } from "@saleor/fragments/types/StaffErrorFragment";
import { FormChange } from "@saleor/hooks/useForm";
import { SearchPermissionGroups_search_edges_node } from "@saleor/searches/types/SearchPermissionGroups";
import { FetchMoreProps, SearchPageProps } from "@saleor/types";
import { getFormErrors } from "@saleor/utils/errors";
import getStaffErrorMessage from "@saleor/utils/errors/staff";
import React from "react";
import { useIntl } from "react-intl";

import SingleAutocompleteSelectField from "../SingleAutocompleteSelectField";

export interface AccountPermissionGroupProps
  extends FetchMoreProps,
    SearchPageProps {
  formData: {
    permissionGroup: string;
  };
  disabled: boolean;
  errors: StaffErrorFragment[];
  availablePermissionGroups: SearchPermissionGroups_search_edges_node[];
  onChange: FormChange;
  displayValue: string;
}

const AccountPermissionGroup: React.FC<AccountPermissionGroupProps> = props => {
  const {
    availablePermissionGroups,
    disabled,
    displayValue,
    errors,
    formData,
    hasMore,
    loading,
    onChange,
    onFetchMore,
    onSearchChange
  } = props;

  const intl = useIntl();
  // console.log('availablePermissionGroups');
  // console.log(availablePermissionGroups);
  const choices = availablePermissionGroups?.map(pg => ({
    label: pg.name,
    value: pg.id
  }));
  const formErrors = getFormErrors(
    ["addGroups", "removeGroups", "permissionGroup"],
    errors
  );
  return (
    <>
      <SingleAutocompleteSelectField
        idInputTxt="userTypeTxt"
        error={!!formErrors.permissionGroup}
        helperText={getStaffErrorMessage(formErrors.permissionGroup, intl)}
        displayValue={!!formData?.permissionGroup ? displayValue : ""}
        disabled={disabled}
        label={intl.formatMessage({
          defaultMessage: "User Type"
        })}
        choices={
          choices
            ? choices.filter(choice =>
                choice.label !== "Superuser" ? choice : ""
              )
            : []
        }
        name="permissionGroup"
        value={formData?.permissionGroup}
        onChange={onChange}
        fetchChoices={onSearchChange}
        data-test="permissionGroup"
        onFetchMore={onFetchMore}
        hasMore={hasMore}
        loading={loading}
      />
      {!!formErrors.addGroups && (
        <Typography color="error">
          {getStaffErrorMessage(formErrors.addGroups, intl)}
        </Typography>
      )}
      {!!formErrors.removeGroups && (
        <Typography color="error">
          {getStaffErrorMessage(formErrors.removeGroups, intl)}
        </Typography>
      )}
    </>
  );
};

AccountPermissionGroup.displayName = "AccountPermissionGroup";
export default AccountPermissionGroup;
